import { Button, Result } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

function AdminProtectedRoute({ children }) {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAdminRole();
  }, []);

  const checkAdminRole = () => {
    try {
      const userData = localStorage.getItem('user');
      if (userData) {
        const user = JSON.parse(userData);
        const admin = user.role === 'admin' || user.role === 'ADMIN';
        setIsAdmin(admin);
        setLoading(false);
        return;
      }
      
      // Пробуем получить роль из токена
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      
      // Проверяем demo-token
      if (token === 'demo-token') {
        setIsAdmin(true);
        setLoading(false);
        return;
      }
      
      // Проверяем demo-jwt- токены
      if (token.startsWith('demo-jwt-')) {
        try {
          const base64Part = token.replace('demo-jwt-', '');
          const decoded = JSON.parse(atob(base64Part));
          setIsAdmin(decoded.role === 'admin' || decoded.role === 'ADMIN');
        } catch (e) {
          setIsAdmin(false);
        }
        setLoading(false);
        return;
      }
      
      // Для обычных JWT токенов нужно проверить через API
      setIsAdmin(false);
      setLoading(false);
    } catch (error) {
      setIsAdmin(false);
      setLoading(false);
    }
  };

  if (loading) {
    return null; // ProtectedRoute покажет загрузку
  }

  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Доступ запрещен. Эта страница доступна только для администраторов."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Вернуться на главную
          </Button>
        }
      />
    );
  }

  return children;
}

// Обертка для использования с ProtectedRoute
function AdminProtectedRouteWrapper({ children }) {
  return (
    <ProtectedRoute>
      <AdminProtectedRoute>
        {children}
      </AdminProtectedRoute>
    </ProtectedRoute>
  );
}

export default AdminProtectedRouteWrapper;
























